import Vue from 'vue'
import Vuex from 'vuex'
import referrals from './modules/referrals';
import Swal from 'sweetalert2'
Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
      Navbar: false,
      Modal: false,
      isModalVisible: false,
      Source: ''
    },
    actions: {
      steamConfirm(){
        Swal.fire({
          title: '<strong class="swalSteamTitle">Thanks for subscribing!</strong>',
          html:
            '<p class="swalSteamContent">Don\'t forget to wishlist on Steam</p>',
          focusConfirm: false,
          confirmButtonText:
            '<a href="https://store.steampowered.com/app/1132760/Dwerve/" target="_blank" class="swalSteamLink">Add to your wishlist</a>',
          confirmButtonAriaLabel: 'Wishlist!',
        });
        // gtag('event', 'Sign Up', 'Suscribe', 'Suscribe Form', 1);
        gtag('event', 'Suscribe', {
          'event_category': 'Sign Up',
          'event_label': 'Suscribe Form',
          'value':1
          });
      },
      steamConfirmFromModal(){
        Swal.fire({
          title: '<strong class="swalSteamTitle">Thanks for subscribing!</strong>',
          html:
            '<p class="swalSteamContent">Don\'t forget to wishlist on Steam</p>',
          focusConfirm: false,
          confirmButtonText:
            '<a href="https://store.steampowered.com/app/1132760/Dwerve/" target="_blank" class="swalSteamLink">Add to your wishlist</a>',
          confirmButtonAriaLabel: 'Wishlist!',
        }).then(() => {
          document.getElementById("mySendyModal").style.display = "none";
        });
        // gtag('event', 'Sign Up', 'Suscribe', 'Suscribe Form', 1);
        gtag('event', 'Suscribe', {
          'event_category': 'Sign Up',
          'event_label': 'Suscribe Form',
          'value':1
          });
      },
      pointModal(){
        Swal.fire({
          title: '<strong class="swalPledgeTitle">Are you sure you want to change your email?</strong>',
          html:
            '<ul class="pointList">You should only change your email if it does not match your Kickstarter email. Changing your email will generate a new link and points will not carry over to the new email. Are you sure you want to change your email?</ul>',
          focusConfirm: false,
          confirmButtonText:
            '<a href="https://url.halfhumangames.com/kickstarter-ws" target="_blank" class="refPointLink">Proceed</a>',
          confirmButtonAriaLabel: 'pointLink',
        })
      },
      helperModal(){
        Swal.fire({
          title: '<strong class="swalPledgeTitle">How to spend your points?</strong>',
          html:
            '<ul class="pointList"><li>Enter your Kickstarter email and select your pledge tier</li><li><strong>Share your referral link</strong> and earn points for each referral</li><li>After the Kickstarter ends, we will send a <strong>survey</strong> asking how you want to spend your points</li></ul>',
        })
      },
      getCookie(name){
        var cookieArr = document.cookie.split(";");
        for(var i = 0; i < cookieArr.length; i++) {
            var cookiePair = cookieArr[i].split("=");
            if(name == cookiePair[0].trim()) {
                return decodeURIComponent(cookiePair[1]);
            }
        }
        return null;
      },
      gtagTest1(){
        gtag('event', 'Product Click', {
          'event_category': 'ecommerce',
          'event_label': 'Pledge',
          'value': 15.00
        });
      },
      gtagTest2(){
        dataLayer.push({
          'event': 'Fake-Kickstarter',
          'label': 'pledge',
          'transactionId': Math.floor(Math.random() * 10),
          'transactionAffiliation': 'Dwerve Kickstarter Ltd',
          'transactionTotal': 85,
          'transactionTax': 10,
          'transactionShipping': 5,
          'transactionProducts': [{
              'sku': 'Dwerve221',
              'name': 'Dwerve Tier v12',
              'category': 'Pledge',
              'price': 20,
              'quantity': 1
          
          }]
        });
      },
      gtagTest3(){
        dataLayer.push({
          'event': 'Fake-Kickstarter',
          'label': 'pledge',
          'transactionId': Math.floor(Math.random() * 10),
          'transactionAffiliation': 'Dwerve Kickstarter Ltd',
          'transactionTotal': 120,
          'transactionTax': 10,
          'transactionShipping': 5,
          'transactionProducts': [{
              'sku': 'Dwerve11',
              'name': 'Dwerve Tier v11',
              'category': 'Pledge',
              'price': 80,
              'quantity': 1
          
          }]
        });
      },
      gtagTest4(){
        dataLayer.push({
          'event': 'Fake-Kickstarter',
          'label': 'test tag',
          'transactionId': Math.floor(Math.random() * 10),
          'transactionAffiliation': 'Dwerve Clothes Ltd',
          'transactionTotal': 155,
          'transactionTax': 30,
          'transactionShipping': 5,
          'transactionProducts': [{
              'sku': 'PNETShoe11',
              'name': 'Dwerve Shoes v11',
              'category': 'Pledge',
              'price': 50,
              'quantity': 2
          
          }]
        });
      }
    },
    mutations: {
      
    },
    modules: {
      referrals
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js